import Swiper from 'swiper/bundle'

$(document).ready(function () {

    const currentUrl = encodeURIComponent(window.location.href);
  
    $('#vkShare').attr(
      'href',
      'https://vk.com/share.php?url=' + currentUrl
    );

    $('#tgShare').attr(
      'href',
      'https://t.me/share/url?url=' + currentUrl
    );

    $('#copyLinkBtn').on('click', function () {
  
      navigator.clipboard.writeText(window.location.href)
        const $copyMessage = $('.copy__message');
        $copyMessage.addClass('active');

        setTimeout(function () {
            $copyMessage.removeClass('active');
        }, 3000);
  
    });

    function switchTab(tabId) {
        $(".blog__nav-item").removeClass("active");
        $(`.blog__nav-item[data-tab="${tabId}"]`).addClass("active");
    
        $(".blog__tab-cnt").removeClass("active").hide();
        $(`#${tabId}-cnt`).addClass("active").show();
    }
    
    $(".blog__nav-item").on("click", function (e) {
        e.preventDefault();
        const tabId = $(this).data("tab");
        switchTab(tabId);
    });

    const BLOG_VISIBLE_COUNT = 9;
    const BLOG_STEP = 3;
    const BLOG_ANIM_DURATION = 400;

    function initBlogMore() {
        $('.blog__tab-cnt').each(function () {
            const $tab = $(this);
            const $items = $tab.find('.blog__item-list .blog__item');
            const $btn = $tab.find('.blog__more-btn');

            if ($items.length > BLOG_VISIBLE_COUNT) {
                $items.slice(BLOG_VISIBLE_COUNT).addClass('is-hidden');
            } else {
                $btn.hide();
            }
        });
    }

    initBlogMore();

    function hideMoreBtn($btn) {
        if ($btn.data('isHiding')) return;
        $btn.data('isHiding', true);

        $btn.stop(true, true)
            .animate(
                { opacity: 0, borderTopWidth: 0, borderBottomWidth: 0 },
                { duration: BLOG_ANIM_DURATION, queue: false }
            )
            .slideUp(BLOG_ANIM_DURATION, function () {
                $btn.hide();
            });
    }

    $('.blog__more-btn').on('click', function () {
        const $btn = $(this);
        const $tab = $btn.closest('.blog__tab-cnt');
        const $list = $tab.find('.blog__item-list');
        const $hidden = $list.find('.blog__item.is-hidden');

        if ($list.data('isAnimating')) return;

        if (!$hidden.length) {
            hideMoreBtn($btn);
            return;
        }

        const $toShow = $hidden.slice(0, BLOG_STEP);
        const isLastBatch = $hidden.length <= BLOG_STEP;

        $list.data('isAnimating', true);

        const startHeight = $list.outerHeight();

        $toShow.removeClass('is-hidden').addClass('is-appearing');

        $list.css({ height: 'auto', overflow: 'hidden' });
        const endHeight = $list.outerHeight();

        $list.css({
            height: startHeight,
            overflow: 'hidden',
            transition: 'height ' + BLOG_ANIM_DURATION + 'ms ease'
        });

        void $list[0].offsetHeight;

        $list.css('height', endHeight);
        $toShow.removeClass('is-appearing');

        function finish() {
            $list.off('transitionend', onTransitionEnd);
            clearTimeout(fallbackTimer);
            $list.css({ height: '', overflow: '', transition: '' });
            $list.data('isAnimating', false);

            if (isLastBatch) {
                hideMoreBtn($btn);
            }
        }

        function onTransitionEnd(e) {
            if (e.target !== $list[0]) return;
            if (e.originalEvent && e.originalEvent.propertyName !== 'height') return;
            finish();
        }

        $list.on('transitionend', onTransitionEnd);
        const fallbackTimer = setTimeout(finish, BLOG_ANIM_DURATION + 100);
    });

    new Swiper('.swiper.other__blog', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
            nextEl: '.tab-next',
            prevEl: '.tab-prev',
        },
        pagination: {
          el: '.other__blog__swiper-pagination',
        },
    })

    $('.blog__aside a').on('click', function (e) {
        e.preventDefault();
      
        const targetId = $(this).attr('href');
        const $target = $(targetId);
      
        if (!$target.length) return;
      
        window.scrollTo({
          top: $target.offset().top - 100,
          behavior: 'smooth'
        });
    });

    $('.faq__top').click(function () {
      $(this)
        .toggleClass('active')
        .next()
        .stop(true, true)
        .slideToggle(500);
    
      $('.faq__top')
        .not(this)
        .removeClass('active')
        .next()
        .stop(true, true)
        .slideUp(500);
    });
  
});